(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["animated-story"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const items = document.querySelectorAll('[data-animated-story-item]:not(.is-visible)');
      if (!items.length) return;

      if (typeof IntersectionObserver === 'undefined') {
        items.forEach((el) => el.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
      );

      items.forEach((el) => observer.observe(el));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', (event) => {
      const target = event.target;
      if (target && target.matches && target.matches('[data-animated-story-item]')) {
        target.classList.add('is-visible');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
